import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {connect} from 'react-redux'
import R from 'ramda'

import Spacer from './Spacer'
import SortColumnField from './SortColumnField'

import toggleEstateList from '../actions/toggleEstateList'
import changeSort from '../actions/changeSort'

import getCurrentQuery from '../utils/getCurrentQuery'

const QuerySummary = ({queryMetaData, sort, currency, areaUnit, options, onShowFilters, onChangeSort})=> {
  const query = getCurrentQuery()
  const nbTypes = R.length(query.features.estateTypes) 
  
  return <div className="query-summary-container">
    <br/>

    <div style={{display:'flex', flexDirection:'column'}}>
    <label className="title-category"><span>Vos Résultats</span></label>
      <div style={{display:'flex', flexDirection:'column', flexBasis:'50%', marginRight:'10px', marginBottom:'10px'}}>
        <div style={{display:'flex', justifyContent: 'flex-end'}}>
          <Spacer/>
          <FormattedMessage id="nb result found" 
                            defaultMessage="{nbResults, plural, =0 {no estates found} one {one estate found} other {# estates found}}"
                            values={{nbResults: queryMetaData.nbResults}}/>
          &nbsp; 
          (<FormattedNumber value={queryMetaData.time} style="decimal"/> {' '} ms)
        </div>
      </div>
      <div style={{display:'flex', flexDirection:'column', flexBasis:'50%', marginRight:'10px'}}>
        <div style={{display:'flex', justifyContent: 'flex-end'}}>
          <FormattedMessage id="Sorted by" defaultMessage="Sorted by"/>
          <Spacer/>
          <SortColumnField options={options} sortColumn={sort.name} onChange={(newColumn) => onChangeSort(newColumn)}/>
        </div>
      </div>
    </div>
  </div>
}

QuerySummary.propTypes = {
  options: React.PropTypes.object.isRequired,
  queryMetaData: React.PropTypes.shape({
    nbResults: React.PropTypes.number.isRequired,
    time: React.PropTypes.number.isRequired,
    nbLikes: React.PropTypes.number,
    nbZones: React.PropTypes.number,
  }),
  sort: React.PropTypes.shape({
    name: React.PropTypes.string.isRequired
  }).isRequired,
  savedList: React.PropTypes.string,
  
  onShowFilters: React.PropTypes.func.isRequired,
  onChangeSort: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    queryMetaData: state.queryMetaData,
    sort: state.sort,
    options: state.options,
    currency: state.currency,
    areaUnit: R.prop('name', R.find(R.propEq('name', state.areaUnit), state.options.areaUnits)),
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onShowFilters: _ => dispatch(toggleEstateList()),
    onChangeSort: (name) => dispatch(changeSort(ownProps.query, name)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuerySummary)



/** WEBPACK FOOTER **
 ** ./app/components/QuerySummary.jsx
 **/